import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getAgenciasBancarias } from '../../../api';
import StatusPesquisar from '../../../components/status_pesquisar';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'codigo', headerName: 'Código', width: 200 },
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
var AgenciasBancarias = function () {
    return (_jsx(GridBase, { pagina: PAGINAS.AGENCIAS_BANCARIAS, paginaPermissao: FUNCIONALIDADES.AGENCIAS_BANCARIAS, rota: ROUTES.AGENCIAS_BANCARIAS, columns: COLUNAS, filtrosIniciais: { situacao: '-1' }, fetchData: function (busca, filtros, paginacao) { return getAgenciasBancarias(busca, filtros.situacao === '-1' ? null : filtros.situacao, paginacao); }, renderFiltros: function (filtros, atualizar) { return (_jsx(StatusPesquisar, { StatusPesquisa: filtros.situacao, filtrarGrid: function (_, novaSituacao) {
                atualizar({ situacao: novaSituacao });
            } })); } }));
};
export default AgenciasBancarias;
